<template>
    <v-fade-transition>
        <v-sheet
            v-show="expand && isDownloadSuccess !== null"
            :height="500"
            class="d-flex flex-column"
        >
            <v-spacer class="mt-12"/>
            <v-img
                class="mt-12"
                :width="150"
                :max-height="150"
                contain
                :src="getImageByState"
            />
            <v-spacer class="py-2"/>
            <div
                class="h2 download-title green-text text-darken-2 font-weight-bold text-center pb-2"
                :class="{
                    'green-text': isDownloadSuccess,
                    'orange-text': !isDownloadSuccess
                }"
            >
                {{ getTextByState }}
            </div>
            <v-card-text
                v-if="isDownloadSuccess"
                class="text-center pa-0 habiteo-body-2 grey-text font-weight-bold"
                style="line-height: 20px;"
            >
                {{ $t('habiteoStudio.downloadCompleteInfo') }}
            </v-card-text>
            <v-spacer/>
        </v-sheet>
    </v-fade-transition>
</template>

<script>
    import { EventBus } from '@/event-bus';

    export default {
        name: 'StepDownload',
        data() {
            return {
                expand: false,
                exportSuccessImg: require('@/assets/images/export-success.png'),
                exportFailImg: require('@/assets/images/export-fail.png')
            }
        },
        props: {
            isDownloadSuccess: {
                type: Boolean,
                required: true
            }
        },
        computed: {
            getImageByState() {
                return this.isDownloadSuccess ? this.exportSuccessImg : this.exportFailImg;
            },
            getTextByState() {
                return this.isDownloadSuccess ? this.$t('habiteoStudio.downloadComplete') : this.$t('habiteoStudio.downloadFailed');
            }
        },
        mounted() {
            EventBus.$on('setDownloadState', state => this.sucess = state);
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/myHabiteoStudio/steps/StepDownload.vue